// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { addISOWeekYears as fn } from "../addISOWeekYears.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const addISOWeekYears = convertToFP(fn, 2);

// Fallback for modularized imports:
export default addISOWeekYears;
